import { ErrorMessage } from '../../lib-shared/ErrorMessage';

export const ErrorMessageMap = new Map([
  [ErrorMessage.ORDER_ARTICLETRACKING_REF_NOTFOUND, `Article introuvable`],
  [ErrorMessage.ORDER_ARTICLETRACKING_PIN_NOTFOUND, ``],
  [ErrorMessage.ORDER_ARTICLETRACKING_ALREADY_TIDIED, `Article déjà scanné`],
  [ErrorMessage.ORDER_ARTICLETRACKING_WITH_OPEN_DEFECT, `Défauts sur l'article non résolus.`],
  [ErrorMessage.ORDER_ARTICLETRACKING_ORDER_ALREADY_FINISH, `Étiquette périmée`],
  [ErrorMessage.NO_STORAGE_AVAILABLE, `Aucun emplacement disponible`],
  [ErrorMessage.INCORRECT_CREDENTIAL, ``],
  [ErrorMessage.INVALID_TOKEN, ``],
  [ErrorMessage.ACCOUNT_DISABLED, ``],
  [ErrorMessage.ORDER_ALREADY_PAID, `Votre commande a déjà été payée`],
  [ErrorMessage.ORDER_ALREADY_FINISH, ``],
  [ErrorMessage.ORDER_NOT_PAYABLE, `Nos équipes effectuent actuellement une correction sur la facturation de votre commande, merci de réitérer votre demande ultérieurement.\n` +
  `Un nouvel email de confirmation de commande vous sera à nouveau adressé prochainement.`],
  [ErrorMessage.NOT_A_DELIVERABLE_ORDER, `L'état de votre commande ne lui permet pas d'être livrée`],
  [ErrorMessage.EMAIL_ALREADY_USED, ``],
  [ErrorMessage.NOT_ALLOWED, ``],
  [ErrorMessage.ORDER_ARTICLETRACKING_IS_NOT_UNTIDIED, ``],
  [ErrorMessage.ORDERBAG_ALREADY_FINISH, ``],
  [ErrorMessage.INVOICE_NOT_AVAILABLE, `Facture non disponible.`],
  [ErrorMessage.ORDER_ARTICLETRACKING_REF_ALREADY_EXIST, ``],
  [ErrorMessage.INCORRECT_VALUE, ``],
  [ErrorMessage.WRONG_PHONE_CODE, 'Code de validation erroné'],
  [ErrorMessage.TRACKINGSHEET_NOT_TIDIABLE, `Fiche de suivi non rangeable`],
  [ErrorMessage.INCORRECT_ENDPOINT, ``],
  [ErrorMessage.ORDER_PAYMENT_PROCESSING, `Le paiement de votre commande est déjà en cours de traitement.`],
  [ErrorMessage.TRACKINGSHEET_NOT_FACTORY_CHECKED, `Fiche de suivi non contrôlée`],
  [ErrorMessage.ORDER_NOT_TEMPORARY, ``],
  [ErrorMessage.ORDER_NOT_TRANSFERABLE, ``],
  [ErrorMessage.ORDERBAG_ALREADY_CHECKED, ``],
  [ErrorMessage.ORDERBAG_NOT_CHECKED, ``],
  [ErrorMessage.TRACKINGSHEET_NOT_TIDIED, ``],
  [ErrorMessage.ORDER_NOT_PAID, `Commande non payée.`],
  [ErrorMessage.ORDER_ARTICLETRACKING_ALREADY_FACTORY, `Article déjà contrôlé`],
  [ErrorMessage.ORDERBAG_IS_LAST_NOT_FINISH_OF_EMPTY_ORDER, `Impossible de clôturer le dernier sac d'une commande vide.`],
  [ErrorMessage.TRANSPORTSHEET_REF_NOTFOUND, `Kit inexistant.`],
  [ErrorMessage.TRANSPORTSHEET_INCORRECT, `Erreur avec votre kit.`],
  [ErrorMessage.TRANSPORTSHEET_ALREADY_YOURS, `Kit déjà associé à votre compte.`],
  [ErrorMessage.TRANSPORTSHEET_ALREADY_BOOKED, `Kit déjà utilisé.`],
  [ErrorMessage.TRANSPORTSHEET_WITHOUT_USER, `Colis non associé à un compte utilisateur.`],
  [ErrorMessage.TRACKINGSHEET_ALREADY_PTLTOOK, `L'article a déjà été retiré dans le PTL.`],
  [ErrorMessage.TRACKINGSHEET_NOT_PTLTOOK, `Un bac est encore dans le PTL.`],
  [ErrorMessage.TRANSPORTSHEET_ALREADY_PRINT, `Étiquette de transport déjà imprimée.`],
  [ErrorMessage.ORDER_KITBATCH_CONTENT_ERROR, `Contenu du lot de kit incorrect.`],
  [ErrorMessage.ORDER_NOT_FOUND, `Commande non trouvée.`],
  [ErrorMessage.TRANSPORTSHEET_NOT_FACTORY_PACK, `Commande pas en statut FACTORY_PACK.`],
  [ErrorMessage.TRANSPORTSHEET_NOT_YOURS, `Kit ne vous appartenant pas.`],
  [ErrorMessage.TRANSPORTSHEET_ALREADY_USED, `Kit déjà utilisé.`],
  [ErrorMessage.PICKUP_NOT_AVAILABLE, `Point relais non disponible.`],
  [ErrorMessage.ORDER_KITBATCHSTOCK_ALREADY_USED, `Lot de kit déjà utilisé.`],
  [ErrorMessage.USER_NOT_UNLIMITEDORDERKIT, ``],
  [ErrorMessage.TRANSPORTSHEET_IS_RETURN, ``],
  [ErrorMessage.TRANSPORTSHEET_IS_NOT_RETURN, `Étiquette colis aller.`],
  [ErrorMessage.TRANSPORTSHEET_ALREADY_FACTORYSENT, `Étiquette déjà expédiée.`],
  [ErrorMessage.TRANSPORTSHEET_USER_DISABLED, `Compte client désactivé.`],
  [ErrorMessage.ORDERSHIPRETURN_ALREADY_VALIDATE, ``],
  [ErrorMessage.ORDERSHIPRETURN_NOT_VALIDATE, ``],
  [ErrorMessage.ORDERSHIPRETURN_ALREADY_SHIP, ``],
  [ErrorMessage.PHONENUMBER_INVALID, `Numéro de téléphone invalide.`],
  [ErrorMessage.CREDIT_NOT_FOUND, `Avoir introuvable.`],
  [ErrorMessage.CREDIT_ALREADY_USED, `Cet avoir a déjà été utilisé.`],
  [ErrorMessage.CREDIT_ALREADY_CANCELLED, `Cet avoir a déjà été annulé.`],
  [ErrorMessage.CREDIT_NOT_EDITABLE, `Un avoir de précommande ne peut pas être modifié.`],
  [ErrorMessage.CREDIT_NOT_CANCELABLE, `Un avoir de précommande ne peut pas être annulé.`],
  [ErrorMessage.USER_HAS_UNFINISHED_ORDER, `Vous ne pouvez pas supprimer votre compte tant qu'une commande est en cours.`],
  [ErrorMessage.USER_ALREADY_DELETED, `Ce compte a été supprimé, il ne peut plus être modifié.`],
  [ErrorMessage.ORDER_HAS_OPEN_DEFECTS, `Des défauts déclarés sur la commande n'ont pas été résolus.`],
  [ErrorMessage.REFERRAL_CODE_INVALID, `Code de parrainage introuvable.`],
  [ErrorMessage.REFERRAL_REFEREE_NOT_ELIGIBLE, `Un code parrainage ne peut être saisi qu'avant votre première commande de linge.`],
]);
